<template>
  <div class="company-approval-company-list">
    <TableList
      v-rect-loading="loading"
      class="approval-company-list"
      row-key="id"
      :title="$t(`${i18nPrefix}.title.companyListTitle`)"
      :listData="companyApprovalList"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      :pagination="pagination"
      :createBtnLabel="$t(`${i18nPrefix}.btn.register`)"
      @pagination-change="loadCompanyApprovalList(false)"
      @create="handleCreate"
    >
      <template #filter>
        <el-input
          v-model="search.keywords"
          clearable
          :placeholder="$t(`${i18nPrefix}.placeholder.inputCompanyName`)"
          @input="handleKeywordsChange"
        />
        <el-select
          v-model="search.status"
          filterable
          clearable
          @change="loadCompanyApprovalList(true)"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.selectedLabel"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="search.deltaMonth"
          filterable
          clearable
          @change="loadCompanyApprovalList(true)"
        >
          <el-option
            v-for="(item, index) in deltaMonthList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
      <template #status="{ data, row }">
        <Dropdown
          :class="`${COMPANY_STATUS_MAP[data]}-status`"
          :value="data"
          :data="filterStatusList(data)"
          @change="handleChangeCompanyStatus($event, row)"
        />
      </template>
      <!-- <template #premium="{ data }">
        <div v-if="data" class="premium-info">
          <div v-if="data.user_num && data.user_num.value != '1'" class="pro-premium-info-item">
            <span class="premium-value">{{ data.user_num.value }}</span>
            <span class="premium-expire-date" :title="formatPremiumExpireDate(data.user_num.expire_date)">{{ formatPremiumExpireMonthDay(data.user_num.expire_date)}}</span>
          </div>
          <div v-if="data.assessments && data.assessments.value === '1'" class="premium-info-item">
            <span class="premium-expire-date" :title="formatPremiumExpireDate(data.assessments.expire_date)">{{ formatPremiumExpireMonthDay(data.assessments.expire_date) }}</span>
          </div>
          <div v-if="data.referral && (data.referral.value === '1' || data.referral.value === '2')" class="premium-info-item">
            <span class="premium-expire-date" :title="formatPremiumExpireDate(data.referral.expire_date)">{{ formatPremiumExpireMonthDay(data.referral.expire_date) }}</span>
          </div>
          <div v-if="data.company_list_level && data.company_list_level.value !== '0'" class="premium-info-item">
            <span class="premium-expire-date" :title="formatPremiumExpireDate(data.company_list_level.expire_date)">{{ formatPremiumExpireMonthDay(data.company_list_level.expire_date) }}</span>
          </div>
        </div>
      </template> -->
    </TableList>
    <DialogWrapper
      v-if="statusChangeDialog.show"
      class="status-change-dialog"
      cancelBtnLabelI18nKey="common.no"
      saveBtnLabelI18nKey="common.yes"
      :closeOnClickModal="false"
      :title="statusChangeDialog.title"
      :loading="statusChangeDialog.loading"
      :show.sync="statusChangeDialog.show"
      @save="handleCompanyStatus"
    />
    <DialogWrapper
      v-if="purgeDataDialog.show"
      class="purge-data-dialog"
      cancelBtnLabelI18nKey="common.no"
      saveBtnLabelI18nKey="common.yes"
      :closeOnClickModal="false"
      :title="purgeDataDialog.title"
      :loading="purgeDataDialog.loading"
      :show.sync="purgeDataDialog.show"
      @cancel="handlePurgeData(false)"
      @save="handlePurgeData(true)"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import moment from 'moment'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import Dropdown from '@/components/formEditor/dropdown.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { COMPANY_STATUS, COMPANY_STATUS_MAP } from '@/constant/company.js'

const i18nPrefix = 'admin.company.companyApprovalManagement'

export default {
  components: {
    TableList,
    Dropdown,
    DialogWrapper
  },
  data () {
    return {
      COMPANY_STATUS_MAP: COMPANY_STATUS_MAP,
      i18nPrefix: i18nPrefix,
      loading: false,
      companyApprovalList: [],
      actionBtn: {
        view: {
          show: true,
          onclick: this.handleView,
          labelI18nKey: `${i18nPrefix}.label.view`
        },
        editor: {
          show: true,
          onclick: this.handleEdit,
          labelI18nKey: 'common.btn.edit'
        },
        premiumSetup: {
          show: true,
          onclick: this.handlePremiumSetup,
          labelI18nKey: `${i18nPrefix}.btn.premiumSetup`
        }
      },
      search: {
        keywords: null,
        status: COMPANY_STATUS.NEW,
        deltaMonth: null
      },
      pagination: {
        total: 1,
        page: 1,
        pageSize: 10
      },
      statusChangeDialog: {
        show: false,
        loading: false,
        title: null,
        content: null,
        row: null,
        status: null
      },
      purgeDataDialog: {
        show: false,
        loading: false,
        title: null,
        content: null,
        purgeData: false
      }
    }
  },
  computed: {
    statusList () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.pending`),
          selectedLabel: this.$t(`${this.i18nPrefix}.label.pending`),
          value: COMPANY_STATUS.PENDING
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.new`),
          selectedLabel: this.$t(`${this.i18nPrefix}.label.new`),
          value: COMPANY_STATUS.NEW
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.reject`),
          selectedLabel: this.$t(`${this.i18nPrefix}.label.rejected`),
          value: COMPANY_STATUS.REJECTED
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.approve`),
          selectedLabel: this.$t(`${this.i18nPrefix}.label.approved`),
          value: COMPANY_STATUS.APPROVED
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.close`),
          selectedLabel: this.$t(`${this.i18nPrefix}.label.closed`),
          value: COMPANY_STATUS.CLOSED
        }
      ]
    },
    deltaMonthList () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.withinOneMonth`),
          value: '1'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.withinTwoMonth`),
          value: '2'
        }
      ]
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.companyName`),
          dataKey: 'i18nName',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.registeredDate`),
          dataKey: 'created_time',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'status',
          slotName: 'status'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.expirationDate`),
          dataKey: 'expire_date'
        }
        // {
        //   label: this.$t(`${this.i18nPrefix}.label.functions`),
        //   dataKey: 'company_premium',
        //   width: '170px',
        //   slotName: 'premium',
        //   showOverflowTooltip: false
        // }
      ]
      return columns
    }
  },
  watch: {
    $router () {
      this.getRouteFromUrl()
      this.handleRouteChange()
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('companyManagement', ['getCompanyApprovalList', 'updateCompanyApprovalStatus']),
    async initPage () {
      this.loading = true
      try {
        this.getRouteFromUrl()
        this.handleRouteChange()
        this.loadCompanyApprovalList()
      } finally {
        this.loading = false
      }
    },
    async loadCompanyApprovalList (reload) {
      if (reload) {
        this.pagination.page = 1
        this.pagination.total = 0
      }
      this.handleRouteChange(true)
      const params = {
        keywords: this.search.keywords,
        page: this.pagination.page,
        page_size: this.pagination.pageSize
      }
      if (this.search.status) {
        params.status = this.search.status
      }
      if (this.search.deltaMonth) {
        params.delta_months = this.search.deltaMonth
      }
      this.loading = true
      try {
        const resp = await this.getCompanyApprovalList(params)
        if (resp) {
          this.pagination.total = resp.total_count
          this.companyApprovalList = _.forEach(resp.result || [], item => {
            item.created_time = moment(item.created_time).format('YYYY-MM-DD') || ''
            item.expire_date = item.company_premium?.company_expire?.expire_date ? moment(item.company_premium.company_expire.expire_date).format('YYYY-MM-DD') : ''
            item.name = item.name || item.cn_name || ''
            item.cn_name = item.cn_name || item.name || ''
            addI18nProperty(item, 'i18nName', 'cn_name', 'name')
          })
        }
      } finally {
        this.loading = false
      }
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(() => this.loadCompanyApprovalList(true), 1000)
      }
      this.keywordsSearchDebounce()
    },
    filterStatusList (data) {
      const statusList = _.cloneDeep(this.statusList)
      _.forEach(statusList, item => {
        if (item.value === data) {
          item.disabled = true
        }
      })
      return statusList
    },
    formatPremiumExpireDate (date) {
      return date ? moment(date).format('YYYY-MM-DD') : ''
    },
    formatPremiumExpireMonthDay (date) {
      return date ? moment(date).format('MM-DD') : ''
    },
    handleChangeCompanyStatus (status, row) {
      this.changeStatusDialogData(false, status, row)
    },
    changeStatusDialogData (init, status, row) {
      if (init) {
        this.statusChangeDialog.loading = false
        this.statusChangeDialog.show = false
        this.statusChangeDialog.row = null
        this.statusChangeDialog.status = null
      } else {
        const statusTip = this.$t(`${this.i18nPrefix}.label.${COMPANY_STATUS_MAP[status]}`)
        const title = this.$t(`${this.i18nPrefix}.label.companyStatusTip`, { status: statusTip })
        this.statusChangeDialog.title = title
        this.statusChangeDialog.status = status
        this.statusChangeDialog.row = row
        this.statusChangeDialog.show = true
      }
    },
    purgeDataDialogData (init) {
      if (init) {
        this.purgeDataDialog.loading = false
        this.purgeDataDialog.show = false
        this.purgeDataDialog.purgeData = false
      } else {
        this.purgeDataDialog.title = this.$t(`${this.i18nPrefix}.label.purgeDataTip`)
        this.purgeDataDialog.show = true
      }
    },
    handleCompanyStatus () {
      const status = this.statusChangeDialog.status
      const row = this.statusChangeDialog.row
      if (status === COMPANY_STATUS.CLOSED && row.is_root_company) {
        this.purgeDataDialogData(false)
      } else {
        this.updateCompanyStatus()
      }
    },
    handlePurgeData (purgeData) {
      this.purgeDataDialog.purgeData = purgeData
      this.purgeDataDialogData(true)
      this.updateCompanyStatus()
    },
    async updateCompanyStatus () {
      const status = this.statusChangeDialog.status
      const row = this.statusChangeDialog.row
      this.statusChangeDialog.loading = true
      try {
        const data = {
          company_id: row.id,
          from_status: row.status,
          to_status: status
        }
        if (this.purgeDataDialog.purgeData) {
          data.purge_data = true
        }
        await this.updateCompanyApprovalStatus(data)
        this.loadCompanyApprovalList(true)
      } finally {
        this.changeStatusDialogData(true)
      }
    },
    handleView (row) {
      this.$router.push({
        path: `/v-admin/client-management/company/${row.id}`,
        query: { keywords: this.search.keywords, status: this.search.status || 0, deltaMonth: this.search.deltaMonth }
      })
    },
    handleEdit (row) {
      this.$router.push({
        path: `/v-admin/client-management/company/${row.id}/edit/`,
        query: { keywords: this.search.keywords, status: this.search.status || 0, deltaMonth: this.search.deltaMonth, back: this.$route.fullPath }
      })
    },
    handleCreate () {
      const url = this.$router.resolve({
        path: '/passport/company/register',
        query: { back: this.$route.fullPath }
      }).href
      window.open(url, '_blank')
    },
    handlePremiumSetup (row) {
      this.$router.push({
        path: `/v-admin/client-management/company/${row.id}/premium/`,
        query: { keywords: this.search.keywords, status: this.search.status || 0, deltaMonth: this.search.deltaMonth, back: this.$route.fullPath }
      })
    },
    getRouteFromUrl () {
      const keywords = this.$route.query.keywords
      if (keywords) {
        this.search.keywords = keywords
      }
      const status = this.$route.query.status
      if (status === '0') {
        this.search.status = null
      } else if (status) {
        this.search.status = status
      }
      const deltaMonth = this.$route.query.deltaMonth
      if (deltaMonth) {
        this.search.deltaMonth = deltaMonth
      }
    },
    handleRouteChange (isPush) {
      const keywords = this.$route.query.keywords
      let status = this.$route.query.status
      if (status === '0') {
        status = null
      }
      const deltaMonth = this.$route.query.deltaMonth
      if (((keywords || this.search.keywords) && keywords !== this.search.keywords) ||
        ((status || this.search.status) && status !== this.search.status) ||
        ((deltaMonth || this.search.deltaMonth) && deltaMonth !== this.search.deltaMonth)) {
        isPush
          ? this.$router.push({ query: { keywords: this.search.keywords, status: this.search.status || 0, deltaMonth: this.search.deltaMonth } })
          : this.$router.replace({ query: { keywords: this.search.keywords, status: this.search.status || 0, deltaMonth: this.search.deltaMonth } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.approval-company-list {
  ::v-deep {
    .pending-status {
      .label {
        color: #efb133;
      }
    }
    .new-status {
      .label {
        color: #89ba27;
      }
    }
    .rejected-status {
      .label {
        color: #ea6d3c;
      }
    }
    .approved-status {
      .label {
        color: #0f9242;
      }
    }
    .closed-status {
      .label {
        color: #d71518;
      }
    }
  }
  .premium-info {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;

    .pro-premium-info-item {
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      margin: 5px 0px 5px 22px;

      .premium-value {
        background-color: #ccc;
        padding: 0px 5px;
      }

      .premium-expire-date {
        background-color: #fff;
      }

      .premium-value::before {
        content: '';
        position: absolute;
        top: 17px;
        left: 20px;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-right: 12px solid #ccc;
      }

      .premium-expire-date {
        padding: 0px 5px;
      }
    }

    .premium-info-item {
      display: flex;
      align-items: center;
      position: relative;
      overflow: hidden;
      margin: 5px 0px 5px 10px;

      .premium-expire-date {
        border: 1px solid #ccc;
        border-left: 0px;
        margin-left: 13px;
        padding: 0px 5px;
        background-color: #fff;
      }

      .premium-expire-date::after {
          content: '';
          position: absolute;
          top: 0px;
          left: 2px;
          width: 0;
          height: 0;
          z-index: 1;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          border-right: 12px solid #fff;
      }

      .premium-expire-date::before {
          content: '';
          position: absolute;
          top: 0px;
          left: 1px;
          width: 0;
          height: 0;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          border-right: 12px solid #ccc;
      }
    }
  }
}
</style>
